export default __webpack_public_path__ + "static/media/pridevideo1.3665ee8f.mp4";